import { createBlock as e, createCommentVNode as t, createElementBlock as n, createElementVNode as r, createTextVNode as i, createVNode as a, defineComponent as o, normalizeClass as s, onBeforeMount as c, openBlock as l, ref as u, toDisplayString as d, unref as f, watch as p, withCtx as m } from "vue";
import { QBtn as h, QCard as g, QCardSection as _, QDialog as v, QIcon as y, useFormChild as b } from "quasar";
import { quasarValidateRules as x } from "@editor/ui-utils";
import { getGallery as S } from "@modules/gallery-editor-ui";
import { EditorImage as C } from "@modules/image-editor-ui-components";
import { ContentList as w } from "@modules/news-article-editor-ui";
import { getContent as T, useEditorContent as E } from "@modules/news-article-editor-ui-components";
import { getVideo as D } from "@modules/video-editor-ui";
import { useI18n as O } from "vue-i18n";
//#region src/selectors/article-list.selector.vue?vue&type=script&setup=true&lang.ts
var k = { class: "row justify-center items-center align-center text-center" }, A = { class: "col-6" }, j = { class: "article-wrapper" }, M = { class: "teaser-preview" }, N = {
	key: 0,
	class: "play-btn"
}, P = { class: "article-detail" }, F = { class: "article-kicker" }, I = { class: "article-title" }, L = { class: "article-date" }, R = { class: "q-field__messages text-negative col" }, z = ["textContent"], B = /* @__PURE__ */ ((e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
})(/* @__PURE__ */ o({
	__name: "article-list.selector",
	props: {
		modelValue: { default: void 0 },
		rules: { default: void 0 },
		disable: {
			type: Boolean,
			default: !1
		}
	},
	emits: [
		"update:article",
		"update:modelValue",
		"update:block:imageUuid",
		"update:block:mediaType"
	],
	setup(o, { emit: B }) {
		let V = o, H = B, U = () => ({
			_id: "",
			bfJobUuid: "",
			title: "",
			leadText: "",
			articleAuthorshipRef: {
				type: "news_article",
				authorUuids: []
			},
			channelUuid: "",
			secondaryChannelUuids: [],
			hasAffiliate: !1,
			mainMediaRef: {
				mediaType: "image",
				imageUuid: ""
			},
			contentsRef: [{
				type: "BACKGROUND_ARTICLE",
				contentUuid: "",
				teaser: "",
				mediaType: ""
			}],
			isDeleted: !1,
			isHiddenFromNewsticker: !1,
			isHiddenFromTeaserList: !1,
			isTeaserDataShown: !1,
			createDate: /* @__PURE__ */ new Date(),
			changeDate: /* @__PURE__ */ new Date(),
			state: "draft",
			seoTitle: "",
			isNoIndex: !1,
			tracking: { pageContentSourceDetail: "" },
			paths: [{
				path: "",
				type: "custom",
				createDate: /* @__PURE__ */ new Date(),
				brand: "bunte"
			}],
			slug: "",
			ads: {
				adTags: [],
				hasAdvertisementMark: !1,
				isAdsEnabled: !1,
				isOutstreamEnabled: !0
			},
			feeds: {
				msnAt: "exclude",
				msnCh: "exclude",
				msnDe: "auto",
				yahoo: "auto"
			},
			type: "CONTENT",
			brand: "bunte",
			legacy: {
				isEditableInCTF: !0,
				isRenderedByCTF: !0,
				hasBeenModifiedInCTF: !0,
				source: "vibe"
			},
			vgwortPixel: {
				pixelUrl: "",
				isLegacyPixel: !1
			},
			articleType: "news"
		}), { t: W } = O(), G = u(!1), K = u(!0), q = u(U()), J = E(), Y = u(""), X = u(), Z = () => {
			let e = x(q.value, V.rules);
			K.value = !e, Y.value = e;
		};
		b({
			validate() {
				return Z(), K.value || X.value?.scrollIntoView({
					behavior: "smooth",
					block: "center",
					inline: "center"
				}), K.value;
			},
			resetValidation() {
				K.value = !0;
			}
		});
		let Q = async (e) => {
			let t;
			switch (e.mainMediaRef.mediaType) {
				case "image":
					t = e.mainMediaRef.imageUuid;
					break;
				case "gallery":
					t = (await S(e.mainMediaRef.galleryUuid)).references[0]?.uuid;
					break;
				case "video":
					t = (await D(e.mainMediaRef.videoUuid)).posterImageUuid;
					break;
			}
			return t;
		}, $ = async (e) => {
			e.listingImageUuid ||= await Q(e), q.value = e, H("update:article", e), H("update:modelValue", q.value._id), H("update:block:imageUuid", e.listingImageUuid ?? ""), H("update:block:mediaType", e.mainMediaRef.mediaType), G.value = !1, Z();
		};
		return c(async () => {
			if (V.modelValue) {
				let e = await T(V.modelValue);
				e.listingImageUuid ||= await Q(e), q.value = e;
			}
		}), p(() => V.modelValue, async () => {
			if (V.modelValue) {
				let e = await T(V.modelValue);
				e.listingImageUuid ||= await Q(e), q.value = e;
			} else q.value = U();
			H("update:article", q.value), Y.value = "";
		}, {
			deep: !0,
			immediate: !0
		}), (c, u) => (l(), n("div", {
			ref_key: "wrapper",
			ref: X,
			class: "selector-wrapper"
		}, [a(f(g), {
			flat: "",
			bordered: "",
			class: s({ invalid: !K.value })
		}, {
			default: m(() => [o.modelValue ? (l(), e(f(_), {
				key: 1,
				class: "q-pa-none"
			}, {
				default: m(() => [r("div", j, [r("div", M, [q.value.mainMediaRef.mediaType === "video" ? (l(), n("div", N)) : t("", !0), q.value && q.value.listingImageUuid ? (l(), e(f(C), {
					key: 1,
					uuid: q.value.listingImageUuid,
					size: "medium",
					class: "teaser-image"
				}, null, 8, ["uuid"])) : t("", !0)]), r("div", P, [
					r("div", F, d(q.value.kicker), 1),
					r("div", I, d(q.value.title), 1),
					r("div", L, d(q.value.publishDate), 1),
					a(f(h), {
						"data-qa-article-picker-remove-button": "",
						outline: "",
						color: "white",
						"text-color": "black",
						class: "border-btn switch-article-button",
						disable: o.disable,
						onClick: u[3] ||= (e) => G.value = !0
					}, {
						default: m(() => [i(d(f(W)("backgroundArticle.switchLabel")), 1)]),
						_: 1
					}, 8, ["disable"])
				])])]),
				_: 1
			})) : (l(), e(f(_), {
				key: 0,
				"data-qa-article-picker": "",
				class: "custom-article-wrapper q-mt-md",
				onClick: u[2] ||= (e) => G.value = !0
			}, {
				default: m(() => [r("div", k, [r("div", A, [q.value._id ? t("", !0) : (l(), e(f(y), {
					key: 0,
					modelValue: q.value._id,
					"onUpdate:modelValue": u[0] ||= (e) => q.value._id = e,
					size: "36px",
					name: "file-text",
					color: "grey-5"
				}, null, 8, ["modelValue"])), q.value._id ? t("", !0) : (l(), e(f(_), {
					key: 1,
					modelValue: q.value._id,
					"onUpdate:modelValue": u[1] ||= (e) => q.value._id = e,
					flat: "",
					class: "q-pa-sm",
					color: "white"
				}, {
					default: m(() => [i(d(f(W)("backgroundArticle.selectorLabel")), 1)]),
					_: 1
				}, 8, ["modelValue"]))])])]),
				_: 1
			})), Y.value ? (l(), e(f(_), {
				key: 2,
				class: "q-field__bottom row items-start q-field__bottom--animated"
			}, {
				default: m(() => [r("div", R, [r("div", {
					role: "alert",
					textContent: d(Y.value)
				}, null, 8, z)])]),
				_: 1
			})) : t("", !0)]),
			_: 1
		}, 8, ["class"]), a(f(v), {
			modelValue: G.value,
			"onUpdate:modelValue": u[5] ||= (e) => G.value = e,
			"data-qa-list-gallery-dialog": "",
			"full-width": "",
			"full-height": ""
		}, {
			default: m(() => [a(f(w), {
				brand: f(J).content.brand,
				dialog: !0,
				"hide-close": !0,
				"article-state": "publish",
				onClose: u[4] ||= (e) => G.value = !1,
				"onClick:content:select": $
			}, null, 8, ["brand"])]),
			_: 1
		}, 8, ["modelValue"])], 512));
	}
}), [["__scopeId", "data-v-b94a56d3"]]);
//#endregion
export { B as t };

//# sourceMappingURL=article-list.selector-BH09Mwm5.js.map